/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OutletPosDTO = {
  accountNumber?: string;
  posId?: number;
  serialNumber?: string;
  status?: OutletPosDTO.status;
  terminalId?: string;
};

export namespace OutletPosDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
